/**
 * Modification d'une campagne — portail client. Le formulaire est partagé
 * (`CampagneEditForm`, @repo/campagne) ; la query d'alimentation est
 * org-scopée (`obtenirCampagne`).
 *
 * L'autorisation reste serveur : `campagnes.modifierCampagne` accepte
 * quiconque voit la campagne dans son org/groupe, et refuse une archivée.
 */
import { CampagneEditForm } from "@repo/campagne";
import { PageContainer } from "@repo/ui";
import { useQuery } from "convex/react";
import { useParams } from "react-router";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";

export function CampagneModifier() {
  const { id } = useParams<{ id: string }>();
  const campagneId = id as Id<"campagnes">;

  const campagne = useQuery(api.campagnes.obtenirCampagne, { campagneId });
  const detailHref = `/campagnes/${campagneId}`;

  return (
    <PageContainer>
      {campagne === undefined && (
        <p className="text-sm text-muted-foreground">Chargement…</p>
      )}
      {campagne === null && (
        <p className="text-sm text-muted-foreground">Campagne introuvable.</p>
      )}
      {campagne && (
        <CampagneEditForm
          campagne={campagne}
          retourHref={detailHref}
          retourLabel="Retour à la campagne"
        />
      )}
    </PageContainer>
  );
}
